export default __webpack_public_path__ + "static/media/hero3.89fc1d71.webp";